/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Override_Bitrate_LabelInputs */

const en_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Override Target Bitrate`)
};

const fr_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer le debit cible`)
};

const de_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielbitrate überschreiben`)
};

const it_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci il bitrate di destinazione`)
};

const ru_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить целевой битрейт`)
};

const es_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anular la tasa de bits objetivo`)
};

const zh_cn2_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖目标比特率`)
};

const ja_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットビットレートを上書き`)
};

const hi_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य बिटरेट को ओवरराइड करें`)
};

const pt_pt2_drastic_tech_override_bitrate_label = /** @type {(inputs: Drastic_Tech_Override_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir taxa de bits alvo`)
};

/**
* | output |
* | --- |
* | "Override Target Bitrate" |
*
* @param {Drastic_Tech_Override_Bitrate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_override_bitrate_label = /** @type {((inputs?: Drastic_Tech_Override_Bitrate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Override_Bitrate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_override_bitrate_label(inputs)
	if (locale === "de") return de_drastic_tech_override_bitrate_label(inputs)
	if (locale === "it") return it_drastic_tech_override_bitrate_label(inputs)
	if (locale === "ru") return ru_drastic_tech_override_bitrate_label(inputs)
	if (locale === "es") return es_drastic_tech_override_bitrate_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_override_bitrate_label(inputs)
	if (locale === "ja") return ja_drastic_tech_override_bitrate_label(inputs)
	if (locale === "hi") return hi_drastic_tech_override_bitrate_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_override_bitrate_label(inputs)
	return en_drastic_tech_override_bitrate_label(inputs)
});